"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaInputGroup = void 0;
/* eslint-disable import/no-cycle */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var types_1 = require("../../types");
var field_1 = require("./field");
function SchemaInputGroup(props) {
    var key = props.key, name = props.name, schema = props.schema, group = props.group, currentPath = props.currentPath, _a = props.gap, gap = _a === void 0 ? 12 : _a, _b = props.hideEmptyLabel, hideEmptyLabel = _b === void 0 ? false : _b;
    var inputs = group.inputs, title = group.title, stackDirection = group.stackDirection, preventFullWidth = group.preventFullWidth;
    if (!inputs || inputs.length === 0) {
        return null;
    }
    return (react_1.default.createElement("div", { "data-testid": name + "-SchemaInputGroup-" + key },
        react_1.default.createElement(core_ui_1.Flexbox, { gap: 16, flexDirection: "column" },
            title && (react_1.default.createElement(core_ui_1.Flexbox, { gap: 8, flexDirection: "column" },
                react_1.default.createElement(core_ui_1.Title, { size: 17 }, title),
                react_1.default.createElement(core_ui_1.Divider, null))),
            react_1.default.createElement(core_ui_1.Flexbox, { gap: gap, flexDirection: (0, core_ui_1.stackDirectionToFlexDirection)(stackDirection || core_ui_1.StackDirectionType.HORIZONTAL) }, inputs.map(function (propertyKey) {
                var component = (react_1.default.createElement(field_1.SchemaInputField, { name: name, propertyKey: propertyKey, schema: schema, currentPath: currentPath, hideEmptyLabel: hideEmptyLabel, preventFullWidth: preventFullWidth }));
                if (preventFullWidth) {
                    return (react_1.default.createElement(core_ui_1.Flexbox, { key: propertyKey, alignItems: "flex-end" }, component));
                }
                return (react_1.default.createElement(core_ui_1.Flexbox, { key: key + "-" + propertyKey, alignItems: group.alignnment === types_1.GroupInputsAlignment.TOP ? 'flex-start' : 'flex-end', flexGrow: 1, flexBasis: 0, style: {
                        width: '100%',
                    } }, component));
            })))));
}
exports.SchemaInputGroup = SchemaInputGroup;
